import { render, staticRenderFns } from "./AdminActions.vue?vue&type=template&id=0c08f724&scoped=true&"
import script from "./AdminActions.vue?vue&type=script&lang=ts&"
export * from "./AdminActions.vue?vue&type=script&lang=ts&"
import style0 from "./AdminActions.vue?vue&type=style&index=0&id=0c08f724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c08f724",
  null
  
)

export default component.exports